import { render, staticRenderFns } from "./leftB-temp3.vue?vue&type=template&id=1bbd54d9&scoped=true"
import script from "./leftB-temp3.vue?vue&type=script&lang=js"
export * from "./leftB-temp3.vue?vue&type=script&lang=js"
import style0 from "./leftB-temp3.vue?vue&type=style&index=0&id=1bbd54d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbd54d9",
  null
  
)

export default component.exports